//资讯接口集合
import config from '@/utils/config'
const iApi = {
	 //获取威新闻列表
	// page,rows
	 getNews: function(postData) {
		return fly.post(config.wapApi + 'app/information/getNews',postData);
	},
	 //获取威知识（文化）更多列表
	// page,rows,informationCategory---默认传201，在旧的H5上看到的请求，暂且不清楚
	 getCulturesMore: function(postData) {
		return fly.post(config.wapApi + 'app/information/getCulturesMore',postData);
	},
	 //获取威视界更多列表
	// page,rows
	 getVideo: function(postData) {
		return fly.post(config.wapApi + 'app/information/getVideo',postData);
	},
	//id  资讯id
	 //获取资讯详情
	 selectById: function(id) {
		return fly.post(config.wapApi + `app/information/selectById/${id}`);
	},
  //id  视频id
  //获取视频详情
  videoDetail: function(id) {
    return fly.post(config.wapApi + `app/video/detail`,{id:id});
  },
//  获取视频评论
  getComments: function(postData) {
    return fly.post(config.wapApi + 'app/video/comments',postData);
  },
}

export default iApi



// WEBPACK FOOTER //
// ./src/utils/api/iApi.js